import React from "react";
import { Trash } from "@phosphor-icons/react";
import { useI18n } from "../contexts/I18nContext";

export default function LeaderboardRow({ rank, name, picture, points, bets, isMe, onRemove }) {
  const { t } = useI18n();
  const top = rank <= 3;
  return (
    <div
      className={`flex items-center gap-3 py-3 px-3 rounded-xl ${isMe ? "bg-[#02371b] text-white" : "border-b border-neutral-100 last:border-0"}`}
      data-testid={`leaderboard-row-${rank}`}
    >
      <span className={`font-mono-tab font-bold w-7 text-center text-sm ${isMe ? "text-white" : top ? "text-[#41a42b]" : "text-neutral-400"}`}>
        {rank}
      </span>
      <div className={`w-9 h-9 rounded-full overflow-hidden flex-shrink-0 border ${isMe ? "border-white/30" : "border-neutral-200 bg-neutral-50"}`}>
        {picture ? (
          <img src={picture} alt="" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-xs font-bold text-neutral-500">
            {(name || "?")[0]?.toUpperCase()}
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className={`font-bold text-sm truncate ${isMe ? "text-white" : "text-[#02371b]"}`}>{name}</div>
        <div className={`text-[10px] ${isMe ? "text-white/50" : "text-neutral-400"} font-medium`}>{bets ?? 0} {t("tips_count")}</div>
      </div>
      <div className="flex items-center gap-3">
        <div className="font-mono-tab font-bold text-sm">{points}</div>
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className="text-destructive hover:text-destructive/80 hover:bg-destructive/10 p-1.5 rounded-lg transition-colors flex-shrink-0"
            title={t("remove_member")}
          >
            <Trash size={14} weight="bold" />
          </button>
        )}
      </div>
    </div>
  );
}
